import moment from 'moment';
// 출발일,도착일. 시간을 24시간으로 나누어서 올림. 1달은 30일로 계산
const getFullYearString = yymmdd => {
    const thisYear_YY = ('' + moment().year()).substring(0, 2);
    const myBirth_YY = yymmdd.substring(0, 2);
    return myBirth_YY > thisYear_YY ? `19${yymmdd}` : `20${yymmdd}`;
};

export default getFullYearString;
